module.exports = __webpack_public_path__ + "img/vr.4086ee76.png";